<template>
  <div id="anchor-settings" class="form-card publish-setting">
    <h4>發佈設定</h4>
    <b-row>
      <b-col md="12" class="mb-3">
        <AGCLabel required>
          <slot>發佈時間</slot>
          <template v-slot:subLabel>
            <slot name="subLabel">(優惠券需由 U Lifestyle 批核後才會被顯示於 U Lifestyle 平台，批核需時2-5個工作天)</slot>
          </template>
        </AGCLabel>
        <AGCDateTimePicker
          v-model="inputVal.reward.publishOn"
          rules="required|dateBeforeOrEqual:@優惠開始日期"
          :min="role === 'merchant' ? addDays(new Date(), -1) : null"
          :disabled="readOnly"
          name="發佈開始日期"
          :custom-messages="customMessages.publishOn"
          label="由"
          class="mb-3"
          has-time
        ></AGCDateTimePicker>
        <AGCDateTimePicker
          v-model="inputVal.reward.publishDue"
          :rules="{
            required: true,
            dateAfter: [inputVal.reward.publishOn, true],
            dateBeforeOrEqual: '@優惠結束日期'
          }"
          :min="role === 'merchant' ? addDays(new Date(), -1) : null"
          :disabled="readOnly"
          :custom-messages="customMessages.publishDue"
          name="發佈結束日期"
          label="至"
          class="mb-3"
          has-time
          default-time="23:59:59"
        ></AGCDateTimePicker>
      </b-col>
    </b-row>

    <b-row v-if="role==='admin'" class="mb-3">
      <b-col md="12" class="mb-3 category-tags">
        <AGCCheckbox v-model="inputVal.reward.previewable"
        :disabled="readOnly">
          即將推出
        </AGCCheckbox>
      </b-col>
    </b-row>

    <b-row v-if="role==='admin'" class="mb-3">
      <b-col md="12" class="mb-3 category-tags">
        <AGCCheckboxGroup
          v-model="inputVal.reward.availableOn"
          :disabled="readOnly"
          :options="platforms"
          name="發佈平台"
          label="發佈平台"
          id="availableOn"
          sub-label="可選多項"
          :value-field="'id'"
          rules="required"
          required
        ></AGCCheckboxGroup>
      </b-col>

      <b-col md="12" class="mb-3 category-tags">
        <AGCLabel>
          <slot>發佈平台-封面圖片</slot>
          <template v-slot:subLabel>
            <slot name="subLabel">(最多1張，每張大小上限2mb)</slot>
          </template>
        </AGCLabel>
      </b-col>

      <b-col>
        <DropZone
          v-model="inputVal.covers.hk"
          :read-only="readOnly"
          rules="required"
          name="發佈平台-封面圖片"
          class="mb-3"
          upload-type="rewardCoverWeb"
          id="images"
          dropzoneTitle="港生活"
        ></DropZone>
      </b-col>

      <b-col>
        <DropZone
          v-model="inputVal.covers.beauty"
          :read-only="readOnly"
          name="發佈平台-封面圖片"
          class="mb-3"
          upload-type="rewardCoverWeb"
          id="images"
          dropzoneTitle="U Beauty"
        ></DropZone>
      </b-col>

      <b-col>
        <DropZone
          v-model="inputVal.covers.blog"
          :read-only="readOnly"
          name="發佈平台-封面圖片"
          class="mb-3"
          upload-type="rewardCoverWeb"
          id="images"
          dropzoneTitle="U Blog"
        ></DropZone>
      </b-col>

      <b-col>
        <DropZone
          v-model="inputVal.covers.food"
          :read-only="readOnly"
          name="發佈平台-封面圖片"
          class="mb-3"
          upload-type="rewardCoverWeb"
          id="images"
          dropzoneTitle="U Food"
        ></DropZone>
      </b-col>

      <b-col>
        <DropZone
          v-model="inputVal.covers.travel"
          :read-only="readOnly"
          name="發佈平台-封面圖片"
          class="mb-3"
          upload-type="rewardCoverWeb"
          id="images"
          dropzoneTitle="U Travel"
        ></DropZone>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { BCol, BRow } from 'bootstrap-vue';
import { addDays, formatDate } from '@/helpers/date';
import AGCDateTimePicker from '@/components/form/AGCDateTimePicker.vue';
import AGCLabel from '@/components/form/AGCLabel.vue';
import AGCCheckbox from '@/components/form/AGCCheckbox.vue';
import AGCCheckboxGroup from '@/components/form/AGCCheckboxGroup.vue';
import DropZone from '@/components/form/DropZone.vue';
import platforms from '@/data/platforms';

import formMixin from '../../mixins/form';
import vModelMixin from '../../mixins/v-model';

export default {
  mixins: [formMixin, vModelMixin],
  components: {
    AGCDateTimePicker,
    AGCLabel,
    AGCCheckbox,
    AGCCheckboxGroup,
    DropZone,
    BCol,
    BRow,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    customMessages: {
      publishOn: {
        required: '請輸入發佈時間(由)',
        dateAfter: (_, { minDate }) => `發佈時間(由)只能選擇 ${formatDate(minDate, true)} 之後`,
      },
      publishDue: {
        required: '請輸入發佈時間(至)',
        dateAfter: (_, { minDate }) => `發佈時間(至)只能選擇 ${formatDate(minDate, true)} 之後`,
      },
    },
    platforms,
  }),
  computed: {
    ...mapGetters(['role']),
  },
  methods: {
    addDays,
  },
  mounted() {
  },
  watch: {
    'inputVal.covers': function (covers) {
      if (!covers.hk) {
        this.inputVal.covers.hk = 'placeholder/placeholder_UHK.jpg';
      }
      if (!covers.beauty) {
        this.inputVal.covers.beauty = 'placeholder/placeholder_UB.jpg';
      }
      if (!covers.blog) {
        this.inputVal.covers.blog = 'placeholder/placeholder_UBlog.jpg';
      }
      if (!covers.food) {
        this.inputVal.covers.food = 'placeholder/placeholder_UF.jpg';
      }
      if (!covers.travel) {
        this.inputVal.covers.travel = 'placeholder/placeholder_UT.jpg';
      }
    },
    deep: true,
    'inputVal.reward.previewable': function (previewable) {
      if (previewable) {
        this.inputVal.reward.previewable = true;
      } else {
        this.inputVal.reward.previewable = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
